/**
 * TempPasswordBanner — T27.
 *
 * Shows a one-time temp password with a copy button.
 * Used by both InviteUserModal and the reset-password flow in UsersTab.
 */
import { Alert, Button, CopyButton, Group, Text } from '@mantine/core';
import { IconCheck, IconCopy } from '@tabler/icons-react';

interface Props {
  password: string;
}

export function TempPasswordBanner({ password }: Props) {
  return (
    <Alert data-testid="temp-password-banner" color="green" title="Temporary password">
      <Group gap="xs" wrap="nowrap" align="center">
        <Text span>Temporary password:</Text>
        <CopyButton value={password}>
          {({ copied, copy }) => (
            <Button
              data-testid="copy-temp-password"
              size="compact-xs"
              variant="light"
              leftSection={copied ? <IconCheck size={12} /> : <IconCopy size={12} />}
              onClick={copy}
            >
              {copied ? 'Copied' : 'Copy'}
            </Button>
          )}
        </CopyButton>
        <Text span fw={600}>
          {password}
        </Text>
      </Group>
      <Text size="sm" mt="xs">
        Share this with the user out-of-band — it will not be shown again.
      </Text>
    </Alert>
  );
}
